<template>
  <div class="form-container">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.form-container {
  background-color: #FCFDFF;
  border-radius: 32px;
  padding: 40px;

  @media (max-width: 630px) {
    padding: 32px;
  }

  @media (max-width: 400px) {
    padding: 24px;
  }
}
</style>
